<template>
    <h3 class="m-heading-horizon">{{ this.text }}</h3>
</template>

<script>
    export default {
        name: "heading-horizon",
        props: {
            text: {
                type: String,
                required: true
            }
        }
    }
</script>

<style scoped lang="scss">
    $grid-base: 4.27vw; // 375px幅に対して16px
    $grid-consistent: $grid-base * 0.5;// 375px幅に対して8px
    .m-heading-horizon {
        padding: $grid-consistent;
    }
</style>